import { Navigate, RouteObject } from 'react-router-dom'
import { PorAba } from './a02'
import SimulacoesPage from '@/pages/simulacao/SimulacoesPage'

/**
 * Rotas do A15 (Onda 8) — Financeiro unificado, Agenda e Simulações do consultor.
 *
 * - `/notas-fiscais` foi absorvida pelo Financeiro: vira `/financeiro?aba=nf` (a rota
 *   `financeiro` continua registrada em `router/index.tsx`; o placeholder de
 *   `notas-fiscais` saiu de lá).
 * - `/simulacoes` é a tela do Figma (26:270): simulação de comissão por reserva e Campanha
 *   sobre o motor unificado (`POST /v1/simulacoes/comissao`, bloco 8 D2 de 28/09 — o gate
 *   C2 foi revertido: spread/alíquota/modelo são dado versionado cadastrado pelo ADMIN em
 *   `/simulacoes/politicas`, `rotas/pipeDev5.tsx`). O simulador de crédito/Price legado
 *   (`?aba=simulador`) saiu na P6 (AN-PP6 §7): o backend responde 410 desde a P0 e o produto
 *   já não tem valor/prazo/taxa; o link antigo volta à tela de Simulações.
 * - `/agenda` (com `?aba=pendentes`) já é servida por `rotas/a02.tsx` com a AgendaPage —
 *   nada a registrar aqui.
 */
const rotasA15: RouteObject[] = [
  { path: 'notas-fiscais', element: <Navigate to="/financeiro?aba=nf" replace /> },
  {
    path: 'simulacoes',
    element: (
      <PorAba
        padrao={<SimulacoesPage />}
        abas={{
          simulador: <Navigate to="/simulacoes" replace />,
        }}
      />
    ),
  },
]

export default rotasA15
